<template>
  <div>
    <div class="w-full py-2.5 rounded-lg bg-gray-50 z-50">
      <div class="p-1 flex">
        <div
          @click="selectAppLanguage(lang.code)"
          :class="{
            'text-primary-blue': locale === lang.code,
          }"
          class="flex items-center justify-between w-full"
          v-for="lang in languages"
          :key="lang.code"
        >
          <div class="flex flex-col space-y-1 items-center w-full">
            <div class="rounded-full relative">
              <img v-if="lang.flag" :src="lang.flag" :alt="lang.code" />
              <div
                v-if="locale === lang.code"
                class="absolute bg-black/20 transition-all duration-300 text-white rounded-full top-0 left-0 w-full h-full z-10 flex items-center justify-center"
              >
                <Icon name="ph:check" size="16" />
              </div>
            </div>

            <p class="text-[10px]">{{ $t("languages." + lang.code) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import hyIcon from "@/assets/images/flags/am.svg";
import enIcon from "@/assets/images/flags/en-us.svg";
import ruIcon from "@/assets/images/flags/ru.svg";

import { useI18n, type Locale } from "vue-i18n";

const { locale, setLocale } = useI18n();
const appStore = useAppStore();

export interface LanguageItem {
  title: string;
  code: Locale;
  flag: string | null;
}

const languages = shallowRef<LanguageItem[]>([
  { title: "Armenian", code: "hy", flag: hyIcon },
  { title: "English", code: "en", flag: enIcon },
  { title: "Russian", code: "ru", flag: ruIcon },
]);

const selectAppLanguage = async (code: Locale) => {
  if (!code) return;
  await setLocale(code);
  appStore.closeDrawer();
};
</script>
